import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import cx from "classnames";
import {Button, Modal, ModalBody, UncontrolledTooltip} from "reactstrap";
import 'moment/locale/ru';
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import maxBy from "lodash/maxBy";
import minBy from "lodash/minBy";
import assign from "lodash/assign";
import isEqual from "lodash/isEqual";

import {
    mergeMessages,
    receiveMessage,
    setActiveChat,
    setAllOldMessagesLoaded,
    setMessages,
    setMessagesVisibleLimit,
    viewImage,
    toggleModalImage,
} from "../../../actions/Chats";
import {loadChatById, loadMessages} from "../../../thunks/Chats";
import chatbotEmpty from '../../../assets/utils/images/chatbot-empty.svg';
import {
    CHAT_TYPE_CHANNEL,
    CHAT_TYPE_GROUP,
    MESSAGE_CONTENT_TYPE_IMAGE,
    MESSAGE_CONTENT_TYPE_INLINE,
    MESSAGE_CONTENT_TYPE_VOICE,
    MESSAGE_CONTENT_TYPE_FILE,
    MESSAGE_CONTENT_TYPE_LOCATION,
    MESSAGE_CONTENT_TYPE_CONTACT,
    MESSAGE_CONTENT_TYPE_VIDEO,
    MESSAGE_DIRECTION_SENT,
    MESSAGE_DIRECTION_SYSTEM,
    MESSAGE_STATUS_DELETED,
    MESSAGE_STATUS_DELIVERED,
    MESSAGE_STATUS_FAILED,
    MESSAGE_STATUS_NEW,
    MESSAGE_STATUS_READ,
    MESSAGE_STATUS_SENT,
} from "../../../constants";
import Loader from "react-loaders";

import MessageLocation from "./Components/MessageLocation";
import MessageContact from "./Components/MessageContact";
import MessageDirectionSystem from "./Components/MessageDirectionSystem";
import MessageDate from "./Components/MessageDate";
import MessageAvatar from "./Components/MessageAvatar";
import MessageImage from "./Components/MessageImage";
import MessageFile from "./Components/MessageFile";
import MessageVoice from "./Components/MessageVoice";
import MessageVideo from "./Components/MessageVideo";
import MessageText from "./Components/MessageText";

const iconMessageNew = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15" width="16" height="15">
    <path fill="currentColor"
          d="M9.75 7.713H8.244V5.359a.5.5 0 0 0-.5-.5H7.65a.5.5 0 0 0-.5.5v2.947a.5.5 0 0 0 .5.5h.094l.003-.001.003.002h2a.5.5 0 0 0 .5-.5v-.094a.5.5 0 0 0-.5-.5zm0-5.263h-3.5c-1.82 0-3.3 1.48-3.3 3.3v3.5c0 1.82 1.48 3.3 3.3 3.3h3.5c1.82 0 3.3-1.48 3.3-3.3v-3.5c0-1.82-1.48-3.3-3.3-3.3zm2 6.8a2 2 0 0 1-2 2h-3.5a2 2 0 0 1-2-2v-3.5a2 2 0 0 1 2-2h3.5a2 2 0 0 1 2 2v3.5z"></path>
</svg>;
const iconMessageSent = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15" width="16" height="15">
    <path fill="currentColor"
          d="M10.91 3.316l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"></path>
</svg>;
const iconMessageFailed = <i className='pe-7s-attention' style={{color: 'rgb(255 6 0)'}}/>;
const iconMessageDelivered = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15" width="16" height="15"
                                  className='opacity-6'>
    <path fill="currentColor"
          d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"></path>
</svg>;
const iconMessageRead = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15" width="16" height="15"
                             style={{color: 'rgb(79, 195, 247)'}}>
    <path fill="currentColor"
          d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"></path>
</svg>;
const iconMessageDeleted = <i className='pe-7s-trash'/>;


class MessageList extends Component {
    constructor() {
        super();

        this.state = {
            scheduleMessagesScrollTo: undefined,
            scrollEl: undefined,
            scrolledToBottom: true,
            initialDataLoading: false
        };

        this.setScrollRef = this.setScrollRef.bind(this);
        this.loadInitialData = this.loadInitialData.bind(this);
        this.clearData = this.clearData.bind(this);
        this.loadLastMessagesAPI = this.loadLastMessagesAPI.bind(this);
        this.onMessagesScroll = this.onMessagesScroll.bind(this);
        this.onScrollEnd = this.onScrollEnd.bind(this);
        this.reloadActiveChatAPI = this.reloadActiveChatAPI.bind(this);
        this.loadMessagesAPI = this.loadMessagesAPI.bind(this);
    }

    setScrollRef(ref) {
        this.setState({
            scrollEl: ref
        });
    }

    componentDidMount() {
        const that = this;

        this.checkAndLoadMessages();
        // Конкретный чат
        this.loadInitialData();
        this.loadLastMessagesAPI();
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        /**
         * Если обновился чат или магазин, грузим все по-новой
         */
        if (this.props.messages?.length !== prevProps.messages?.length) {
            if (this.state.scrolledToBottom) {
                this.state.scrollEl.scrollTop = this.state.scrollEl.scrollHeight
            }
        }
        if (this.props.match.url !== prevProps.match.url) {
            this.loadInitialData();
        } else if (this.state.scheduleMessagesScrollTo && !isEqual(this.props.messages, prevProps.messages)) {
            /**
             * Скроллим сообщения так чтобы при прокрутке наверх экран остался на месте
             * Отрицательный скролл отсчитывается снизу блока.
             */
            const messagesDiv = document.querySelector('.app-inner-layout__content .scrollbar-container');
            if (messagesDiv) {
                if (this.state.scheduleMessagesScrollTo >= 0) {
                    messagesDiv.scrollTop = this.state.scheduleMessagesScrollTo;
                } else {
                    messagesDiv.scrollTop = messagesDiv.scrollHeight + this.state.scheduleMessagesScrollTo;
                }
            }

            this.setState({
                scheduleMessagesScrollTo: undefined
            });
        }
    }

    delay = (t, val) => {
        return new Promise((res) => {
            setTimeout(() => {
                res(val ? val : true);
            }, t);
        });
    }

    async checkAndLoadMessages() {
        const that = this;
        while (false !== true) {

            if (!that.props.wsConnected) {
                await this.loadLastMessagesAPI()
                await this.delay(10000)
            } else {
                await this.delay(10000)
            }

        }
    }

    componentWillUnmount() {
        this.clearData();
    }

    loadInitialData() {
        const that = this;
        that.setState(
            {
                initialDataLoading: true
            });
        this.reloadActiveChatAPI(
            (newActiveChat) => {
                if (that.props.wsConnected) {
                    that.loadMessagesAPI(
                        newActiveChat.id,
                        {},
                        true,
                        () => {
                            that.setState(
                                {
                                    initialDataLoading: false
                                });
                        },
                        () => {
                            that.clearData();
                            that.setState(
                                {
                                    initialDataLoading: false
                                });
                        }
                    );
                    // that.props.socket.emit('subscribe_chat', newActiveChat.id);
                } else {

                    that.loadMessagesAPI(
                        newActiveChat.id,
                        {},
                        true,
                        () => {
                            that.setState(
                                {
                                    initialDataLoading: false
                                });
                        },
                        () => {
                            that.clearData();
                            that.setState(
                                {
                                    initialDataLoading: false
                                });
                        }
                    );
                }
            }
        );
    }

    clearData() {
        this.props.setMessages([]);
    };

    loadLastMessagesAPI() {
        if (!this.props.activeChat) {
            return;
        }

        const filters = {};


        if (!isEmpty(this.props.messages)) {
            filters['updated_at__gt'] = maxBy(this.props.messages, 'updated_at')['updated_at'];
            filters['limit'] = 100;
        }

        this.loadMessagesAPI(this.props.activeChat.id, filters, false);
    }

    onScrollEnd(element) {
        if (!this.state.scrolledToBottom) {
            this.setState({
                scrolledToBottom: true
            });
        }
    }

    onMessagesScroll(element) {
        const that = this;
        if (this.state.scrolledToBottom) {
            this.setState({
                scrolledToBottom: false
            });
        }
        if (!this.props.activeChat) {
            return;
        }

        if (element.scrollTop > 60) {
            // Еще не доскроллили до верху
            return;
        }
        if (this.props.messagesRequestSending) {
            // Уже отослали запрос
            return;
        }
        if (this.props.allOldMessagesLoaded) {
            // Все старые сообщения уже загружены
            return;
        }

        if (this.props.messages.length - this.props.messagesVisibleLimit < 2) {

            const filters = {};

            if (!isEmpty(this.props.messages)) {
                filters['ts_in_messenger__lt'] = minBy(this.props.messages, 'ts_in_messenger')['ts_in_messenger'];
                if (!filters['ts_in_messenger__lt']) {
                    filters['created_at__lt'] = minBy(this.props.messages, 'created_at')['created_at'];
                }
                if (filters['ts_in_messenger__lt'] < 1) {
                    filters['ts_in_messenger__lt'] = 1
                }
            }

            that.setState({initialDataLoading: true});
            this.loadMessagesAPI(
                this.props.activeChat.id,
                filters,
                false,
                (response) => {
                    if (response.next === null) {
                        that.setState({initialDataLoading: false});
                        that.props.setAllOldMessagesLoaded(true);
                    }
                }
            );
        }

        this.props.setMessagesVisibleLimit(this.props.messagesVisibleLimit + 20);
    }

    reloadActiveChatAPI(successCallback) {
        const that = this;
        const activeChatId = parseInt(this.props.match.params.activeChatId);

        this.props.setActiveChat(undefined);

        /**
         * Подгрузить из API чат исходя из урла
         */
        this.props.loadChatById(
            activeChatId,
            (response) => {
                that.props.setActiveChat(response);
                successCallback && successCallback(response);
            },
        );
    }

    loadMessagesAPI(
        chatId,
        filters = {},
        replaceOld = true,
        successCallback = undefined,
        errorCallback = undefined,
    ) {
        const that = this;
        const filtersAll = assign(
            {
                limit: 20,
                chat: chatId,
            },
            filters
        );

        this.props.loadMessages(
            filtersAll,
            (response) => {
                if (replaceOld) {
                    that.setState(
                        {
                            scheduleMessagesScrollTo: 999999
                        },
                        () => {
                            that.props.setMessages(response.results);
                        }
                    );
                } else {
                    const messagesDiv = document.querySelector('.app-inner-layout__content .scrollbar-container');
                    that.setState({
                            scheduleMessagesScrollTo: messagesDiv
                                ? (messagesDiv.scrollTop - messagesDiv.scrollHeight)
                                : that.state.scheduleMessagesScrollTo
                        },
                        () => {
                            if (!isEmpty(response.results)) {
                                that.props.mergeMessages(response.results);
                            }
                        });
                }

                successCallback && successCallback(response);
            },
            errorCallback
        )
    }

    render() {
        const isGroup = this.props.activeChat && this.props.activeChat.type === CHAT_TYPE_GROUP;
        const isChannel = this.props.activeChat && this.props.activeChat.type === CHAT_TYPE_CHANNEL;
        const now = new Date();

        const messagesHTML = this.props.messages && this.props.messages.slice(0, this.state.messagesVisibleLimit).reverse().map((message) => {
                    const directionMine = message.direction === MESSAGE_DIRECTION_SENT;
                    const isContentTypeInline = message.content_type === MESSAGE_CONTENT_TYPE_INLINE;

                    if (message.direction === MESSAGE_DIRECTION_SYSTEM) {
                        return <MessageDirectionSystem message={message}/>
                    }

                    let messageIcon;
                    switch (message.status) {
                        case MESSAGE_STATUS_NEW:
                            messageIcon = iconMessageNew;
                            break;
                        case MESSAGE_STATUS_SENT:
                            messageIcon = iconMessageSent;
                            break;
                        case MESSAGE_STATUS_FAILED:
                            messageIcon = iconMessageFailed;
                            break;
                        case MESSAGE_STATUS_DELIVERED:
                            messageIcon = iconMessageDelivered;
                            break;
                        case MESSAGE_STATUS_READ:
                            messageIcon = iconMessageRead;
                            break;
                        case MESSAGE_STATUS_DELETED:
                            messageIcon = iconMessageDeleted;
                            break;
                        default:
                            messageIcon = undefined;
                    }

                    const messageContentHTML = () => {
                        if (!isContentTypeInline) {
                            let content = null;
                            switch(message.content_type) {
                                case MESSAGE_CONTENT_TYPE_IMAGE:
                                    content = <MessageImage message={message} viewImage={this.props.viewImage}/>
                                    break;
                                case MESSAGE_CONTENT_TYPE_FILE:
                                    content = <MessageFile message={message}/>
                                    break;
                                case MESSAGE_CONTENT_TYPE_VOICE:
                                    content = <MessageVoice message={message}/>
                                    break;
                                case MESSAGE_CONTENT_TYPE_VIDEO:
                                    content = <MessageVideo message={message}/>
                                    break;
                                case MESSAGE_CONTENT_TYPE_LOCATION:
                                    content = <MessageLocation message={message}/>
                                    break;
                                case MESSAGE_CONTENT_TYPE_CONTACT:
                                    content = <MessageContact message={message}/>
                                    break;
                                default:
                                    content = <MessageText text={message.text}/>;
                                    break;
                            }
                            return <div className="chat-box flex-column">
                                {!directionMine && isGroup &&
                                    <strong className={cx("opacity-9", {'text-right': directionMine})}>
                                        {get(message, 'bot_user.name')}
                                    </strong>
                                }
                                {content}
                            </div>
                        } else {
                            return <Button disabled color='light'>{message.text}</Button>
                        }
                    }

                    const avatar = directionMine ? chatbotEmpty : (isChannel ? get(this.props.activeChat, 'avatar_url') : get(message, 'bot_user.avatar_url'));

                    return <div className={cx("message", {'justify-content-end': directionMine})} key={message.id}>
                        <div className={directionMine ? 'chat-box-wrapper chat-box-wrapper-right' : 'chat-box-wrapper'}>
                            <MessageAvatar avatar={avatar}/>
                            <div className={`message-content ${message.content_type === MESSAGE_CONTENT_TYPE_LOCATION ? 'message-location' : ''}`}>
                                {messageContentHTML()}
                                <div>
                                    <small className="opacity-6">
                                        <MessageDate message={message} now={now}/>
                                    </small>
                                    {directionMine && messageIcon && <span className="ml-2 opacity-8 message-status">{messageIcon}</span>}
                                    {
                                        message.step && <>
                                            <i className="pe-7s-help1 pull-right ml-2"
                                               style={{marginTop: '4px'}}
                                               id={'message-' + message.id}
                                            />
                                            <UncontrolledTooltip placement="top" target={'message-' + message.id}>
                                                {get(message, 'step.flow.name')}: {get(message, 'step.name')}
                                            </UncontrolledTooltip>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>;
                }
            );

        return <Fragment>
            <PerfectScrollbar
                containerRef={ref => {
                    this.setScrollRef(ref);
                }}
                onYReachEnd={this.onScrollEnd}
                onScrollY={this.onMessagesScroll}
            >
                <div className="table-responsive">
                    <div className="chat-wrapper">
                        {(!messagesHTML || this.props.chatByIdRequestSending || this.state.initialDataLoading) &&
                            <Loader className="mt-2 d-flex align-items-center w-2 flex-column" type="line-scale-party"/>}
                        {messagesHTML}
                    </div>
                </div>
            </PerfectScrollbar>

            <Modal isOpen={!!this.props.imageInChatViewed} toggle={this.props.toggleModalImage} style={{width: 'fit-content', maxWidth: '100%'}}>
                <ModalBody style={{width: 'fit-content'}}>
                    <img src={this.props.imageInChatViewed} className="w-100"/>
                </ModalBody>
            </Modal>
        </Fragment>
            ;
    }
}

const mapStateToProps = state => ({
    wsConnected: state.Chats.wsConnected,
    activeChat: state.Chats.activeChat,
    messages: state.Chats.messages,
    messagesRequestSending: state.Chats.messagesRequestSending,
    messagesVisibleLimit: state.Chats.messagesVisibleLimit,
    allOldMessagesLoaded: state.Chats.allOldMessagesLoaded,
    chatByIdRequestSending: state.Chats.chatByIdRequestSending,
    imageInChatViewed: state.Chats.imageInChatViewed,
});

const mapDispatchToProps = dispatch => ({
    setActiveChat: (chat) => dispatch(setActiveChat(chat)),
    loadChatById: (chatId, callback) => dispatch(loadChatById(chatId, callback)),
    loadMessages: (filters, successCallback, errorCallback) => dispatch(loadMessages(filters, successCallback, errorCallback)),
    setMessages: (messages) => dispatch(setMessages(messages)),
    receiveMessage: (message) => dispatch(receiveMessage(message)),
    mergeMessages: (messages) => dispatch(mergeMessages(messages)),
    setAllOldMessagesLoaded: (loaded) => dispatch(setAllOldMessagesLoaded(loaded)),
    setMessagesVisibleLimit: (limit) => dispatch(setMessagesVisibleLimit(limit)),
    viewImage: (image) => dispatch(viewImage(image)),
    toggleModalImage: (some) => dispatch(toggleModalImage(some)),
});


export default connect(mapStateToProps, mapDispatchToProps)(
    withRouter(MessageList)
);
